module.exports = __webpack_public_path__ + "static/media/banner_4.1e50cef5.jpg";